import SelectWeekday from "@/views/crud/modules/SelectWeekday";
import timepicker from "@/views/crud/modules/timepicker";

export default {
    key: "charging_rate_detail",

    action: ["create","edit","delete"],
    default:{
        peak:"0"
    },
    filters:{
        chargingRateId:{}
    },
    fields: [
        {key: "id"},
        {key: "startTime", type:"componentColumn", component:timepicker },
        {key: "endTime", type:"componentColumn", component:timepicker },
        {key :"fee"},
        {key :"peak", type:"boolean"},
        {key :"point"},
        {key: "maxChargingUnit"},
        // {key: "weekday", type:"componentColumn", component:SelectWeekday, option:[{id:"1",name:"weekday.1"},{id:"2",name:"weekday.2"},{id:"3",name:"weekday.3"},{id:"4",name:"weekday.4"},{id:"5",name:"weekday.5"},{id:"6",name:"weekday.6"},{id:"7",name:"weekday.7"}] },
        {key :"penaltyUnit",field:"penaltyUnit.name", value:"penaltyUnit.id", type:"select"},
        {key :"unit",field:"unit.name", value:"unit.id", type:"select"},
        {key :"penaltyFee"},
        {type: "action-btn", privilege: ["EDIT_CHARGING_RATE"]}
    ],
    options: {
        unit: {
            key: "charging_rate_unit",
            label: "name",
            value: "id",
        },
        penaltyUnit: {
            key: "charging_rate_unit",
            label: "name",
            value: "id",
        }
    },
    structure:[
        ["startTime","endTime","peak"],
        ["weekday"],
        ["unit","penaltyUnit"],
        ["fee","penaltyFee"],
        ["point","maxChargingUnit"]
        
    ]
}